import './inputitem.css';
import {ref} from 'vue';

export const InputItem = {

    props: {

        inputType: {
            type: String,
            required: true,
        },
        isCleanable: {
            type: Boolean,
            required: false,
            default: false,
        },
        changeAction: {
            type: Function,
            required: true,
        },
        minLength: {
            type: Number,
            required: false
        },
        maxLength: {
            type: Number,
            required: false
        },
        placeholder: {
            type: String,
            required: false
        },
        minValue: {
            type: Number,
            required: false,
        },
        maxValue: {
            type: Number,
            required: false,
        },
        step: {
            type: Number,
            required: false,
        },
        setRef: {
            type: Function,
            required: false,
        },
        requiredInput: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            inputValue: null,
            cleanableStyles: {
                borderRight: 0,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            },
            input: ref(null),
        };
    },

    methods: {
        onInput(event) {
            const value = event.target.value;
            this.inputValue = value;

            if (typeof this.changeAction === 'function') {
                this.changeAction(value);
            }
        },
        clearInput() {
            this.inputValue = null;
            if (typeof this.changeAction === 'function') {
                this.changeAction(null);
            }
        },
        HandleClick() {
            this.onClick();
        },
    },


    mounted() {
        if (this.setRef) {
            this.setRef(this.$refs.input);
        }
    },

    // language=Vue
    template:
        `
          <div class="ymap-inputfield_container">
            <input
                class="ymap-inputfield_input"
                v-model="inputValue"
                :type="inputType"
                :placeholder="placeholder? placeholder : null"
                :min="inputType === 'number' ? minValue : null"
                :max="inputType === 'number' ? maxValue : null"
                :step="inputType === 'number' ? step : null"
                :minlength="inputType === 'text' ? minLength : null"
                :maxlength="inputType === 'text' ? maxLength : null"
                @input="onInput"
                :style="isCleanable? cleanableStyles: null"
                ref="input"
                :required="requiredInput"
                
            >
            <div
                v-if="isCleanable"
                @click="clearInput"
                class="ymap-inputfield_clear"
            >
              &times;
            </div>
          </div>
        `
}